import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  IconButton,
  useTheme,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import PhoneIcon from '@mui/icons-material/Phone';
import ColorData from 'Components/CstmTheme/ColorData';

interface ContactUsDialogProps {
  open: boolean;
  onClose: () => void;
}

const ContactUsDialog: React.FC<ContactUsDialogProps> = ({ open, onClose }) => {
  const handleCall = () => {
    window.open('tel:+919326024128', '_self');
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 4,
          px: 2,
          py: 1,
          boxShadow: 6,
          backgroundColor: ColorData.background.default,
        },
      }}
    >
      <DialogTitle
        sx={{
          textAlign: 'center',
          fontWeight: 700,
          fontSize: '1.3rem',
          color: ColorData.heading.main,
          position: 'relative',
          pb: 0,
        }}
      >
        Need Assistance?
        <IconButton
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: ColorData.text.primary,
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent
        sx={{
          textAlign: 'center',
          pt: 2,
          pb: 1,
        }}
      >
        <Typography variant="body1" sx={{ mb: 2, color: ColorData.text.primary }}>
          For any questions or support, feel free to contact us at:
        </Typography>

        <Box
          sx={{
            fontSize: '1.6rem',
            fontWeight: 600,
            color: ColorData.primary.main,
            mb: 1,
          }}
        >
          +91 9326024128
        </Box>

        <Typography variant="body2" sx={{ color: ColorData.text.primary, mb: 2 }}>
          We’re available 9 AM to 6 PM, Monday to Saturday.
        </Typography>
      </DialogContent>
    </Dialog>
  );
};

export default ContactUsDialog;
